import {useCallback, useContext, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {EventCreateContext} from '~/common/FabricInvitation/EventCreateDesign/EventCreateContext';
import {
  selectEditorDisabled,
  selectRecentTextColors,
} from '~/common/fabric/reducers/fabricDesign/selectors';
import {ColorPicker} from './ColorPicker';

export const TextColorPicker = ({showAll}) => {
  const [textColor, setTextColor] = useState('#000');
  const {canvas, activeObjects} = useContext(EventCreateContext);
  const editorDisabled = useSelector(selectEditorDisabled);
  const recentTextColors = useSelector(selectRecentTextColors);

  // biome-ignore lint/correctness/useExhaustiveDependencies: deps
  useEffect(() => {
    const updateFillColor = () => setTextColor(canvas?.getActiveObjects()?.[0]?.fill);

    updateFillColor();
    canvas?.on('object:reset', updateFillColor);

    return () => {
      canvas?.off('object:reset', updateFillColor);
    };
  }, [canvas, activeObjects]);

  const onChangeHandler = useCallback(
    (color) => {
      const activeObjs = canvas.getActiveObjects();
      setTextColor(color);
      activeObjs.forEach((obj) => obj.set('fill', color));
      canvas.requestRenderAll();
      canvas.fire('object:modified');
    },
    [canvas]
  );

  return (
    <ColorPicker
      recentColors={recentTextColors}
      reduxKey="recentTextColors"
      editorDisabled={editorDisabled}
      className="create-flow-color-picker"
      color={textColor}
      showColors
      dataQaIdPrefix="step1-text"
      onChangeHandler={onChangeHandler}
      showAll={showAll}
      recentColorLimit={7}
      isTextColorPicker
    />
  );
};
